@if (formGroup) {
  <app-dropdown-control
    [fg]="formGroup"
    [formGroupOrControlName]="formGroupOrControlName"
    [label]="label"
    [options]="options"
    [multiple]="false"
    [noLabel]="false"
    (onChange)="onChange($event)"
  ></app-dropdown-control>
}
